module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/header-image-mobile-04-d3bab7937b6f2289adba89ed56f0a29f.jpg";